import type { AccountId, AssetNamespace, AssetReference, ChainId } from '@shapeshiftoss/caip'

import type { DefiProvider } from '@/state/slices/opportunitiesSlice/types'
import { DefiType } from '@/state/slices/opportunitiesSlice/types'

export const DefiTypeDisplayName = {
  [DefiType.Staking]: 'Staking',
}

export enum DefiAction {
  Overview = 'overview',
  Deposit = 'deposit',
  Withdraw = 'withdraw',
  GetStarted = 'get-started',
  Claim = 'claim',
  SendDust = 'send-dust',
}

export enum DefiStep {
  Info = 'info',
  Approve = 'approve',
  AllowanceReset = 'allowanceReset',
  Confirm = 'confirm',
  Sweep = 'sweep',
  Status = 'status',
}

export type DefiParams = {
  provider: DefiProvider
  earnType: DefiType
  action: DefiAction
}

export type DefiQueryParams = {
  accountId?: AccountId
  defaultAccountId?: AccountId
  chainId: ChainId
  highestBalanceAccountAddress?: string
  contractAddress: string
  assetNamespace: AssetNamespace
  assetReference: AssetReference
  rewardId: string
  modal: string
  provider: string
  type: string
}

export type DefiManagerProviderProps = {
  children: React.ReactNode
}
